import { createContext } from 'react';

type SandboxUiContextType = {
  partnerToken: string;
  companyToken: string;
  companyId: string;
  rerenderCta: () => Promise<void>;
} | null;

export const SandboxUiContext = createContext<SandboxUiContextType>(null);
